const Footer = () => {
	return (
		<footer className="px-8 py-6 text-sm text-neutral-600 border-t border-neutral-900 text-center">
			&copy; {new Date().getFullYear()} Designed and Developed by Harshil
		</footer>
	);
};

export default Footer;
